/**
 * The default  application constants should be defined here
 * @type {string}
 */
export const LoginApiUrl: string = "/api/login";
export const SaveUserDetailsApiUrl: string = "users/save";
